/* Nalla Kadai – Deepavali crackers (fireworks) for every page of the store.
   Loaded from snippets/nk-crackers.liquid. Same effect as the Deepavali landing pages,
   which run their own copy, so this file does nothing there.
   Options (data attributes on the <script> tag):
     data-until="2026-11-10"  last day the crackers show (YYYY-MM-DD, store visitors' local date)
     data-repeat="true"       keep launching a cracker every 7–12 s while the visitor is near the top of the page */
(() => {
  const me = document.currentScript;
  const opt = (k, d) => (me && me.dataset[k] != null ? me.dataset[k] : d);

  // Off after the festival, on the Deepavali pages (they have their own), and for visitors who turned off motion.
  const until = /^(\d{4})-(\d{2})-(\d{2})$/.exec(opt("until", ""));
  if (until && new Date() > new Date(+until[1], +until[2] - 1, +until[3], 23, 59, 59)) return;
  if (document.querySelector("[data-nk-root]")) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const repeat = opt("repeat", "true") !== "false";

  const run = () => {
    const canvas = document.createElement("canvas");
    canvas.setAttribute("aria-hidden", "true");
    canvas.style.cssText = "position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000";
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // turmeric, gold, kumkum red, deep orange, pale gold
    const palette = ["227,146,43", "236,178,58", "190,52,42", "214,104,32", "246,206,120"];
    const rand = (a, b) => a + Math.random() * (b - a);
    const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
    let w = 0, h = 0;

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = innerWidth;
      h = innerHeight;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    addEventListener("resize", resize);

    const sprites = {};
    const sprite = (c) => {
      if (sprites[c]) return sprites[c];
      const s = document.createElement("canvas");
      s.width = s.height = 32;
      const g = s.getContext("2d");
      const grd = g.createRadialGradient(16, 16, 0, 16, 16, 16);
      grd.addColorStop(0, "rgba(255,248,226,1)");
      grd.addColorStop(0.18, `rgba(${c},0.95)`);
      grd.addColorStop(0.5, `rgba(${c},0.28)`);
      grd.addColorStop(1, `rgba(${c},0)`);
      g.fillStyle = grd;
      g.fillRect(0, 0, 32, 32);
      return (sprites[c] = s);
    };
    const glow = (x, y, size, c, a) => {
      if (a <= 0) return;
      ctx.globalAlpha = Math.min(1, a);
      ctx.drawImage(sprite(c), x - size / 2, y - size / 2, size, size);
    };

    const small = () => w < 750;
    const sparks = [];
    const rockets = [];
    const flashes = [];

    function explode(x, y, c) {
      const n = small() ? 48 : 72;
      const speed = rand(3.4, 4.6);
      const ring = Math.random() < 0.35;
      for (let i = 0; i < n; i++) {
        const a = (Math.PI * 2 * i) / n + rand(-0.06, 0.06);
        const s = speed * (ring ? rand(0.92, 1) : rand(0.4, 1));
        sparks.push({ x, y, trail: [], vx: Math.cos(a) * s, vy: Math.sin(a) * s, life: 1, decay: rand(0.01, 0.016), c: Math.random() < 0.2 ? palette[4] : c, lw: rand(1.8, 2.6) });
      }
      flashes.push({ x, y, life: 1, size: small() ? 120 : 170, c });
      start();
    }

    function launch() {
      if (document.hidden || scrollY > h * 1.4) return;
      const x = rand(w * 0.15, w * 0.85);
      rockets.push({ x, y: h * 0.62, tx: x + rand(-40, 40), ty: rand(h * 0.1, h * 0.3), c: pick(palette) });
      start();
    }

    setTimeout(launch, 700);
    setTimeout(launch, 1700);
    setTimeout(launch, 2600);
    if (repeat) (function loop() { setTimeout(() => { launch(); loop(); }, rand(7000, 12000)); })();

    let running = false;
    function start() {
      if (running || document.hidden) return;
      running = true;
      requestAnimationFrame(frame);
    }

    function frame() {
      ctx.clearRect(0, 0, w, h);
      for (let i = rockets.length - 1; i >= 0; i--) {
        const r = rockets[i];
        r.x += (r.tx - r.x) * 0.045;
        r.y += (r.ty - r.y) * 0.06;
        glow(r.x, r.y, 10, r.c, 0.95);
        glow(r.x, r.y + 8, 7, r.c, 0.45);
        glow(r.x, r.y + 16, 5, r.c, 0.2);
        if (Math.abs(r.y - r.ty) < 6) { rockets.splice(i, 1); explode(r.x, r.y, r.c); }
      }
      for (let i = flashes.length - 1; i >= 0; i--) {
        const f = flashes[i];
        f.life -= 0.08;
        if (f.life <= 0) { flashes.splice(i, 1); continue; }
        glow(f.x, f.y, f.size * (1.3 - f.life * 0.3), f.c, f.life * f.life * 0.4);
      }
      ctx.lineCap = "round";
      for (let i = sparks.length - 1; i >= 0; i--) {
        const s = sparks[i];
        s.trail.push(s.x, s.y);
        if (s.trail.length > 10) s.trail.splice(0, 2);
        s.vx *= 0.965;
        s.vy = s.vy * 0.965 + 0.035;
        s.x += s.vx;
        s.y += s.vy;
        s.life -= s.decay;
        if (s.life <= 0) { sparks.splice(i, 1); continue; }
        ctx.globalAlpha = s.life * 0.9;
        ctx.strokeStyle = `rgb(${s.c})`;
        ctx.lineWidth = s.lw * (0.6 + s.life * 0.4);
        ctx.beginPath();
        ctx.moveTo(s.trail[0], s.trail[1]);
        ctx.lineTo(s.x, s.y);
        ctx.stroke();
        glow(s.x, s.y, 9 * s.life + 3, s.c, s.life * (0.75 + Math.random() * 0.25));
      }
      ctx.globalAlpha = 1;
      // Nothing on screen: stop drawing until the next cracker.
      if (document.hidden || (!rockets.length && !sparks.length && !flashes.length)) { running = false; return; }
      requestAnimationFrame(frame);
    }

    document.addEventListener("visibilitychange", () => { if (!document.hidden) start(); });
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
